<ng-container
  [formGroup]="formGroupParent"
  *ngIf="!errorToLoad">
  <!-- <mat-label
    *ngIf="variant!=VARIANT_TYPE.check"
    class="mat-body-strong"
    [ngClass]="{'mat-error': hasError}">
    {{label}}
    <span *ngIf="isRequired">*</span>
  </mat-label> -->
  <mat-form-field
    *ngIf="variant==VARIANT_TYPE.text"
    [appearance]="appearance"
    [ngClass]="{'full-width':fullWidth, 'no-padding-bottom': !hasError, 'mat-form-field-readonly': readonly }"
    floatLabel="default">
    <mat-label>
      {{label}}
      <span *ngIf="isRequired !== false">*</span>
    </mat-label>
    <input
      matInput
      [placeholder]="placeholder||label"
      [formControlName]="controlName"
      [disableControl]="disabled"
      [readonly]="readonly"
      [type]="inputProps.type"
      [maxlength]="inputProps.maxlength"
      [step]="inputProps.step"
      [min]="inputProps.min"
      [max]="inputProps.max"
      [value]="value"
      #textComponent>
    <mat-hint
      *ngIf="showCharCount"
      align="end">
      {{textComponent.value.length}} / {{inputProps.maxlength}}
    </mat-hint>
    <mat-error>

      <div *ngIf="formGroupParent.get(controlName).hasError('required')">El campo "{{label}}" es obligatorio</div>
      <div *ngIf="formGroupParent.get(controlName).hasError('email')">
        El campo "{{label}}" debe ser un email válido
      </div>

    </mat-error>
  </mat-form-field>

  <mat-form-field
    *ngIf="variant==VARIANT_TYPE.multiline"
    [appearance]="appearance"
    [ngClass]="{'full-width':fullWidth, 'no-padding-bottom': !hasError }"
    floatLabel="default">
    <mat-label>
      {{label}}
      <span *ngIf="isRequired !== false">*</span>
    </mat-label>
    <textarea
      matInput
      [placeholder]="label"
      [formControlName]="controlName"
      [rows]="rows"
      [disableControl]="disabled"
      [readonly]="readonly"
      #textComponent></textarea>
    <mat-hint
      align="end"
      *ngIf="showCharCount">
      {{textComponent.value.length}} / {{inputProps.maxlength}}
    </mat-hint>
    <!-- <mat-error>
      <ng-container *ngFor="let validation of msgValidations">
        <div *ngIf="formGroupParent.get(controlName).hasError(validation.name)">{{validation.message}}</div>
      </ng-container>
    </mat-error> -->
    <mat-error>

      <div *ngIf="formGroupParent.get(controlName).hasError('required')">El campo "{{label}}" es obligatorio</div>
      <div *ngIf="formGroupParent.get(controlName).hasError('email')">
        El campo "{{label}}" debe ser un email válido
      </div>

    </mat-error>
  </mat-form-field>

  <div
    *ngIf="variant==VARIANT_TYPE.select"
    [ngClass]="{'full-width':fullWidth, 'mat-form-field-select-disabled': disabled, 'select-invalid': hasError }">
    <ng-select
      notFoundText="No hay opciones"
      class="mat-ng-select select-sunedu"
      [appearance]="appearance"
      [items]="options"
      [selectOnTab]="true"
      [bindValue]="bindValue"
      [bindLabel]="bindLabel"
      [clearable]="clearable"
      [formControlName]="controlName"
      [searchable]="true"
      [disableControl]="disabled||readonly"
      [appendTo]="appendTo"
      dropdownPosition="bottom"
      [placeholder]="(label||placeholder) + (isRequired!==false ? ' *': '')"></ng-select>
    <!-- <mat-error>
      <ng-container *ngFor="let validation of msgValidations">
        <div *ngIf="formGroupParent.get(controlName).hasError(validation.name)">
          {{validation.message}}
        </div>
      </ng-container>
    </mat-error> -->
    <div
      class="select-error-container"
      *ngIf="hasError">
      <mat-error
        class="custom-error"
        [@transitionMessages]="'enter'">
        <div *ngIf="formGroupParent.get(controlName).hasError('required')">El campo "{{label}}" es obligatorio</div>
      </mat-error>
    </div>
  </div>

  <!-- <mat-form-field
    *ngIf="variant==VARIANT_TYPE.multiselect"
    class="ng-select-multiple"
    [ngClass]="{'full-width':fullWidth, 'mat-form-field-select-disabled': disabled }"
    floatLabel="default"
  > -->
  <div
    *ngIf="variant==VARIANT_TYPE.multiselect"
    [ngClass]="{'full-width':fullWidth, 'mat-form-field-select-disabled': disabled }">
    <ng-select
      class="mat-body mat-ng-select select-sunedu"
      notFoundText="No hay opciones"
      [appearance]="appearance"
      [items]="options"
      [selectOnTab]="true"
      [bindValue]="bindValue"
      [bindLabel]="bindLabel"
      [multiple]="true"
      [maxSelectedItems]="maxItems"
      [formControlName]="controlName"
      [closeOnSelect]="false"
      [searchable]="true"
      [disableControl]="disabled||readonly"
      [appendTo]="appendTo"
      dropdownPosition="bottom"
      [placeholder]="(label||placeholder) + (isRequired!==false ? ' *': '')">

      <ng-template
        ng-multi-label-tmp
        let-items="items"
        let-clear="clear">
        <div
          class="ng-value"
          *ngFor="let item of (items ? items.slice(0,maxSelectedLabels): [])">
          <span
            class="ng-value-icon right"
            (click)="clear(item)"
            aria-hidden="true">×</span>
          <span
            class="ng-value-label text-label-multiselect"
            [title]="item[bindLabel]">{{item[bindLabel] | textLimit: 45 }}</span>

        </div>
        <div
          class="ng-value"
          *ngIf="items.length > maxSelectedLabels">
          <span class="ng-value-label">{{items.length - maxSelectedLabels}} más...</span>
        </div>
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-item$="item$"
        let-index="index">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            [checked]="item$.selected">
          <label class="form-check-label ml-2 custom-control-label">{{item[bindLabel]}}</label>
        </div>

      </ng-template>
    </ng-select>

    <div
      class="select-error-container"
      *ngIf="hasError">
      <mat-error [@transitionMessages]="'enter'">
        <ng-container *ngFor="let validation of msgValidations">
          <div
            class="custom-error"
            *ngIf="formGroupParent.get(controlName).hasError(validation.name)">
            {{validation.message}}
          </div>
        </ng-container>
      </mat-error>
    </div>

  </div>
  <!-- <mat-error>
      <ng-container *ngFor="let validation of msgValidations">
        <div *ngIf="formGroupParent.get(controlName).hasError(validation.name)">
          {{validation.message}}
        </div>
      </ng-container>
    </mat-error>
  </mat-form-field> -->

  <mat-form-field
    *ngIf="variant==VARIANT_TYPE.datepicker"
    [appearance]="appearance"
    [ngClass]="{'full-width':fullWidth, 'no-padding-bottom': !hasError }"
    floatLabel="default"
    (click)="picker.open()">
    <input
      (click)="picker.open()"
      readonly
      matInput
      [matDatepicker]="picker"
      [placeholder]="label"
      [formControlName]="controlName"
      [disableControl]="disabled"
      [max]="maxDate"
      [min]="minDate">
    <button
      *ngIf="formGroupParent.get(controlName).value&&!readonly&&!disabled"
      class="clear-datepicker-icon"
      mat-icon-button
      matSuffix
      (click)="HandleClearValue()">
      <mat-icon matSuffix>close</mat-icon>
    </button>

    <mat-datepicker-toggle
      *ngIf="!readonly"
      matSuffix
      [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker
      #picker
      [disabled]="readonly||disabled"></mat-datepicker>
    <mat-error>
      <div *ngIf="formGroupParent.get(controlName).hasError('required')">El campo "{{label}}" es obligatorio</div>
      <!-- <ng-container *ngFor="let validation of msgValidations">
       <div *ngIf="formGroupParent.get(controlName).hasError(validation.name)">{{validation.message}}</div>
      </ng-container> -->
    </mat-error>
  </mat-form-field>

  <ng-container *ngIf="variant==VARIANT_TYPE.check">
    <div
      [ngClass]="{'full-width':fullWidth }"
      class="mat-form-field">

      <mat-checkbox
        class="mat-form-field"
        [formControlName]="controlName"
        [disableControl]="disabled || readonly">
        {{label}}
      </mat-checkbox>

      <div class="mat-form-field-subscript-wrapper checkbox-error-container">
        <mat-error>
          <ng-container *ngFor="let validation of msgValidations">
            <div *ngIf="formGroupParent.get(controlName).hasError(validation.name) && formGroupParent.get(controlName).touched">{{validation.message}}</div>
          </ng-container>
        </mat-error>
      </div>
    </div>
  </ng-container>

  <mat-form-field
    *ngIf="variant==VARIANT_TYPE.timepicker"
    [ngClass]="{'full-width':fullWidth, 'no-padding-bottom': !hasError }"
    floatLabel="default">
    <input
      aria-label="seleccione hora"
      [ngxTimepicker]="defaultTime"
      matInput
      [placeholder]="placeholder||label"
      [formControlName]="controlName"
      [disableControl]="disabled"
      readonly>
    <ngx-material-timepicker
      #defaultTime
      [defaultTime]="defaultTimeParam"></ngx-material-timepicker>
    <mat-error>
      <div *ngIf="formGroupParent.get(controlName).hasError('required')">El campo "{{label}}" es obligatorio</div>
    </mat-error>
  </mat-form-field>

</ng-container>

<div *ngIf="errorToLoad">Hubo un error al cargar el componente</div>
